import React from "react";
import store from "../store";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import ReactPlayer from "react-player";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import CountDown from "../components/CountDown2"
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import hideOnScroll from '../components/hideonscroll'
import MenuIcon from '@material-ui/icons/Menu';

import { NotificationManager } from 'react-notifications';
import CircularProgress from '@material-ui/core/CircularProgress';

import { Link } from "react-router-dom";

import TopBar from '../components/TopBar';
import Paper from '@material-ui/core/Paper';

import { Redirect } from 'react-router-dom';
import ButtonBase from '@material-ui/core/ButtonBase';
import PowerIcon from '@material-ui/icons/PowerSettingsNew';
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import { FIREBASE } from "../config/firebase";
import Divider from '@material-ui/core/Divider';
import * as STATIC from '../config/static';
import _ from 'lodash';
import moment from "moment"
const DWIDTH = 1024;
if (!firebase.apps.length) {
  firebase.initializeApp(FIREBASE);
}
function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
function validatePhone(phone) {
  var re = /^([0-9]{6,20})$/;
  return re.test(phone);
};

const firestore = firebase.firestore();
//let IS_NAMING = window.location.hostname.toLowerCase()=='www1.namethegiraffe.com'?true:false;
//IS_NAMING = true;


var _this;

class CompHome extends React.Component {
  state = {
    viewDidLoad: false,
  };
  constructor(props) {
    super();
    _this = this;
    this.state={isPlaying:false,time:props.time}
    _this.audio = new Audio("assets/sound/tick.mp3");
    _this.iaudio = new Audio("assets/sound/inner_bg.mp3");
  }
  updateDimensions() {
    //console.log(window.innerWidth);
    // _this.setState({
    //   innerWidth: window.innerWidth,
    //   innerHeight: window.innerHeight
    // });
  }
  componentDidMount() {
    _this.iaudio.currentTime=0;
    _this.iaudio.loop=true;
    _this.iaudio.play();
      this.setState({isPlaying:true})
    // setTimeout(()=>{
    //   this.props.history.push('/competition_rules')
    // },3000)
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    //let encrypted = STATIC.encryptStringWithRsaPublicKey("JK1234");
    //console.log(encrypted);


    // this.setState({
    //   innerWidth: window.innerWidth,
    //   innerHeight: window.innerHeight
    // });
    //window.addEventListener("resize", this.updateDimensions);
    //this.loadBingo();
  }
  componentWillReceiveProps(nextProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (nextProps.time !== this.state.time) {
      this.setState({ time: nextProps.time });
    }
  }

  componentWillUnmount() {
    _this.audio.pause();
    _this.iaudio.pause();
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    _this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }
  handleChange = name => event => {
    //event.preventDefault();
    _this.setState({ [name]: event.target.value });
  };
  onUpdateRemain(remain)
  {
    //console.log("test",remain);
    if(remain==10)
    {
      _this.iaudio.pause();
      _this.audio.play();
    }
    if(remain==1)
    {
      _this.audio.pause();
    }
  }



  render() {
    const { classes,t,comp } = this.props;
    const { loading, wWidth, wHeight } = this.state;
    let width = 1024;
    let height = 640;

    // if (wWidth < width) {
    //   width = wWidth;
    // }

      height = wHeight;

    let sRate = 1024 / 640;
    let tRate = 1567 / 350;
    let asRate = 121 / 2048;
    let tsRate = 1567/2048;
    //if (width / wHeight > sRate) {
      width = wHeight * sRate;
      if(width>wWidth)
      {
          width = wWidth;
          height = width/sRate;
      }
    let tWidth = width*tsRate;
    let tHeight = tWidth/tRate;
    //}
    let fBig = width * 0.07;
    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;
    let fSmaller = width * 0.015;
    let ACCOUNTCOMP = store.getState().ACCOUNTCOMP;
    let SOUND = store.getState().SOUND;

    if (!ACCOUNTCOMP) {

      return (<Redirect to='/competition_login' />);
    }
let shareUrl = `/comp_ranking?comp=${comp.comp_id}&u=${ACCOUNTCOMP.id}&level=${ACCOUNTCOMP.level+1}&round=${_this.props.curRoundIndex}`

    let bWidth = STATIC.calSize(512, DWIDTH, width);
    //console.log(ACCOUNT);
    return (
      <div className={classes.root} style={{backgroundImage:comp&&comp.bg_main&&comp.bg_main.length>0?("url('"+comp.bg_main+"')"):"url('assets/comp/bg_comp.png')"}}>
        <div className={classes.middle} >




            <div className={classes.square} style={{maxWidth:width, width: width,height:height,backgroundImage: comp&&comp.bg_wait&&comp.bg_wait.length>0?("url('"+comp.bg_wait+"')"):"url('assets/comp/bg_wait.png')",
            backgroundPosition: "center center",
            WebkitBackgroundSize: "100% 100%",
            backgroundSize: "100% 100%",position:'relative' }} elevation={4}>

              <div style={{paddingTop:STATIC.calSize(223, DWIDTH, width) + 'px '}}>{" "}</div>
              <div style={{  flexGrow: 1, position: 'relative' }}>

                <div style={{ display: 'flex', height: tHeight,flexDirection:'column', justifyContent: 'center', alignItems: 'center' }}>
                <div  style={{width: tWidth,height:tHeight,backgroundImage: "url('assets/comp/frame.png')",
                backgroundPosition: "center center",
                WebkitBackgroundSize: "100% 100%",
                backgroundSize: "100% 100%",position:'relative' }} elevation={4}>
                <div className="comp_text_gradient2"  style={{marginTop:STATIC.calSize(10, DWIDTH, width),fontSize:fTitle,whiteSpace: "pre",textAlign:'center',lineHeight:fLarge+"px" }}>{t("comp.willbegin",{round:(_this.props.curRound.name||_this.props.curRoundIndex+1)})}</div>
                <div className="comp_text_gradient"  style={{fontSize:fBig,whiteSpace: "pre",textAlign:'center',lineHeight:fBig+"px" }}><div className="comp_text_gradient" style={{display:'inline'}}>{t("comp.in")} </div><CountDown className="comp_text_gradient" onUpdateRemain={this.onUpdateRemain} size={fBig} second={this.state.time} isEnd={this.props.onEnd} /></div>

                </div>

              </div>
              </div>
              <div style={{width,position:'absolute',bottom:STATIC.calSize(1, DWIDTH, width),left:STATIC.calSize(0,DWIDTH, width),display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
                <div className="comp_text_gradient2"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center' }}>{ACCOUNTCOMP.id}</div>

              </div>
              <div  style={{position:'absolute',top:STATIC.calSize(12, DWIDTH, width),left:STATIC.calSize(375,DWIDTH, width),width:width*574/2048,height:(width*574/2048)*377/1427,backgroundImage:"url('assets/comp/square_name.png')",backgroundSize:"100% 100%", textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center' }}>
                <div className="comp_text_gradient"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center',lineHeight:0.8}}>{comp?comp.name:"SUPERBRAIN\nSPEED MATH"}</div>
              </div>
              <div  style={{position:'absolute',top:STATIC.calSize(10, DWIDTH, width),left:STATIC.calSize(280,DWIDTH, width), textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center' }}>
                <img
                  src="assets/comp/sp_logo_red.png"
                  style={{ width: width*154/2048, height: 'auto', display: 'block' }} />
              </div>
              {_this.props.curRoundIndex>0&&<ButtonBase onClick={()=>window.open(shareUrl,"_blank")} style={{position:'absolute',paddingLeft:STATIC.calSize(20, DWIDTH, width),paddingRight:STATIC.calSize(20, DWIDTH, width), textAlign: 'center',display:'flex',justifyContent: 'center', alignItems: 'center',backgroundImage:"url('assets/comp/button.png')",backgroundSize:"100% 100%",top:STATIC.calSize(50, DWIDTH, width),right:STATIC.calSize(10,DWIDTH, width)}}>
                <div className="comp_text_gradient"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center',lineHeight:1 }}>{"Xem lại kết quả"}</div>
              </ButtonBase>}
              <ButtonBase onClick={()=>{

                  if(this.state.isPlaying)
                  _this.iaudio.pause();
                  else
                  {
                    _this.iaudio.currentTime=0;
                    _this.iaudio.loop=true;
                    _this.iaudio.play();
                  }

                  this.setState({isPlaying:!this.state.isPlaying})}} style={{position:'absolute',top:STATIC.calSize(50, DWIDTH, width),left:STATIC.calSize(80,DWIDTH, width)}}>
                <img
                  src="assets/comp/speaker.png"
                  style={{ width: width*asRate, height: 'auto', display: 'block' }} />
              </ButtonBase>
            </div>

        </div>

        <div style={{position:'fixed',bottom:STATIC.calSize(5, DWIDTH, width),left:STATIC.calSize(5,DWIDTH, width)}}>
          <div className="comp_text_gradient2"  style={{fontSize:fNormal,whiteSpace: "pre",textAlign:'center' }}>Online: {this.props.online}</div>

        </div>


      </div>
    );
  }
}

CompHome.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(STATIC.styles2)(STATIC.translate('common')(CompHome));
